import { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";

export default function useSidebarCounts() {

  const [counts, setCounts] = useState({
    callback:          0,
    hold:              0,
    reject:            0,
    sold:               0,
    quality:           0,
    quality_standard:  0,
    quality_low_aq:    0,
    quality_oo:        0,
    validate:          0,
    validate_standard: 0,
    validate_low_aq:   0,
    validate_oo:       0,
  });

  const [loading, setLoading] = useState(false);

  const fetchCounts = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/leads/sidebar-counts");
      setCounts(response.data.data || {});
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCounts();
    const interval = setInterval(fetchCounts, 60000);
    return () => clearInterval(interval);
  }, []);

  return { counts, loading, fetchCounts };
}